import React from 'react'

import './logo.css'

const Logo = () => (
  <svg className="am-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <defs />
    <path
      fillRule="evenodd"
      d="M25.46 0L45 45h-8.487l-3.149-7.714H11.636L8.488 45H0L19.54 0h5.92zm-6.016 16.442L12.115 28l3.502 1.064 3.318-5.234-.167 4.552 3.377 1.018 3.452-5.505-.168 4.55 3.253.98 3.337-5.822-.54-.162-2.398 2.03.297-8.04-3.275-.98-3.563 5.68.174-4.7-3.27-.988z"
    />
  </svg>
)

export default Logo
